export const environment = {
    production: false,
    envName: "stage",
    autoSignIn: true,
    popupForLogin: false,
    cacheLocation: "localStorage",
    instance: "https://login.microsoftonline.com/",
    tenantId: "fd799da1-bfc1-4234-a91c-72b3a1cb9e26",
    clientId: '2319e912-c3b7-4dc8-a89e-d552b415f363',
    redirectUri: 'https://fluidsys-app-stage.azure.chevron.com',
    oidcScopes: ["openid", "profile", "User.Read","offline_access"],
    graphScopes: ["User.Read", "User.Read.All", "Group.Read.All"],
    appApiURL: 'https://fluidsys-api-stage.azure.chevron.com/api/v1/',
    graphApiURL: 'https://graph.microsoft.com',
};
